import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import Divider from '@zenbusiness/zui/Divider';
import Grid from '@zenbusiness/zui/Grid';
import Heading from '@zenbusiness/zui/Heading';
import Link from '@zenbusiness/zui/Link';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { useDashboardPath } from '#client/hooks/useDashboardPath';

import { useProductLandingContext } from '../../contexts/useProductLanding';
import { useProductLandingClickstreamProps } from '../../hooks/useProductLandingClickstreamProps';

function RelatedProductsSection() {
  const dashboardPath = useDashboardPath();
  const {
    productConfig: { relatedProducts },
  } = useProductLandingContext();
  const personalizationClickstreamProps = useProductLandingClickstreamProps();
  const { entitlements } = useBusinessEntity();

  if (!relatedProducts) {
    return null;
  }

  const { title, items: allItems } = relatedProducts;
  const items = (allItems || []).filter((item) => !entitlements.has(item.entitlement));

  if (items.length === 0) {
    return null;
  }

  return (
    <>
      <Divider />
      <Stack gap={3} marginBlockStart={4}>
        <Heading component="h2" size="xl" wrap="wrap">
          <FormattedMessage id={title} />
        </Heading>

        <Grid container spacing={2}>
          {items.map((item) => {
            const to = `${dashboardPath}/products/${item.productSlug}`;
            return (
              <Grid item xs={12} md={6} key={item.productSlug}>
                <Link
                  to={to}
                  target="_blank"
                  clickstreamProps={{
                    ...personalizationClickstreamProps,
                    elementName: 'product_card',
                    elementPosition: 'related_products',
                    destination: to,
                    elementValue: item.entitlement,
                  }}
                  sx={{ textDecoration: 'none' }}
                >
                  <Card sx={{ padding: 2 }}>
                    <Stack gap={1.25}>
                      <Stack direction="row" alignItems="flex-start" justifyContent="space-between">
                        <Text size="md" weight="medium" color="primary">
                          <FormattedMessage id={item.title} />
                        </Text>
                        <Box width={{ xs: '1rem', md: '1.125rem' }} height={{ xs: '1rem', md: '1.125rem' }}>
                          <SharedAsset
                            alt=""
                            aria-hidden="true"
                            src="/s2/material-icons/openinnewrounded.svg"
                            width="100%"
                            height="100%"
                          />
                        </Box>
                      </Stack>
                      <Text size="sm" color="secondary">
                        <FormattedMessage id={item.description} />
                      </Text>
                    </Stack>
                  </Card>
                </Link>
              </Grid>
            );
          })}
        </Grid>
      </Stack>
    </>
  );
}

RelatedProductsSection.propTypes = {};

export default RelatedProductsSection;
